/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_OFFICE } from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { AccountingDrawRuleListTabComponent } from './components/accounting-draw-rule-list-tab/accounting-draw-rule-list-tab.component';
import { AccountingTabContainerComponent } from './components/accounting-tab-container/accounting-tab-container.component';
import { DrawRuleDetailsComponent } from './components/draw-rule-details/draw-rule-details.component';
import { AccountingDrawRuleListTabBusinessService } from './resources/accounting-draw-rule-list-tab-business.service';
import { DrawRuleDetailsBusinessService } from './resources/draw-rule-details-business.service';

const routes = [
  createRoute({
    path: '',
    component: AccountingTabContainerComponent,
    children: [
      createRoute({
        path: 'draw-rules',
        component: AccountingDrawRuleListTabComponent,
        init: AccountingDrawRuleListTabBusinessService,
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: [
            'Setup.Accounting.DrawRules.LIST',
          ],
        },
      }),
    ],
  }),
  createRoute({
    path: 'draw-rules/new',
    component: DrawRuleDetailsComponent,
    init: DrawRuleDetailsBusinessService,
    leave: true,
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
      permission: [
        'Setup.Accounting.DrawRules.CREATE',
      ],
    },
  }),
  createRoute({
    path: 'draw-rules/:drawRuleId',
    component: DrawRuleDetailsComponent,
    init: DrawRuleDetailsBusinessService,
    leave: true,
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
      permission: [
        'Setup.Accounting.DrawRules.EDIT',
        'Setup.Accounting.DrawRules.VIEW',
      ],
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupAccountingRoutingModule {

}
